class PopupManager {
    #element;
    #wrapper;
    static #popupList;

    constructor(id) {
        this.#element = document.getElementById(id);
        this.#element.querySelectorAll("[data-close]").forEach((el) => {
            el.addEventListener("click", (ev) => {
                this.close();
                ev.preventDefault();
                return false;
            });
        });
        this.#wrapper = document.getElementById("popup-wrapper");

        PopupManager.#popupList = PopupManager.#popupList || []
        PopupManager.#popupList.push(this)
    }

    open() {
        this.#element.hidden = false;
        this.#wrapper.hidden = false;
    }

    close() {
        this.#element.hidden = true;
        this.#wrapper.hidden = true;
    }

    static getManagerList() {
        return PopupManager.#popupList
    }
}

document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll("[data-target]").forEach((el) => {
        const popupId = el.getAttribute("data-target");
        const formName = el.getAttribute("data-form");

        if(formName && formConfig[formName]) {
            hbspt.forms.create(formConfig[formName]);
        }

        const popup = new PopupManager(popupId);
        el.addEventListener("click", () => {
            popup.open();
        });
    });

    document.getElementById("popup-wrapper").addEventListener("click", () => {
        PopupManager.getManagerList().forEach(m => m.close());
    });

    document.addEventListener("keydown", (ev) => {
        if(ev.key == "Escape") {
            PopupManager.getManagerList().forEach(m => {
                m.close();
            })
        }
    });
});
